import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/auth';

const DEFAULT_MIN_MS = 1500;

export function useSplashGate(minMs: number = DEFAULT_MIN_MS): boolean {
  const [minElapsed, setMinElapsed] = useState(false);
  const [hydrated, setHydrated] = useState(() =>
    useAuthStore.persist.hasHydrated()
  );

  useEffect(() => {
    const timer = window.setTimeout(() => setMinElapsed(true), minMs);
    const unsubscribe = useAuthStore.persist.onFinishHydration(() =>
      setHydrated(true)
    );

    return () => {
      window.clearTimeout(timer);
      unsubscribe();
    };
  }, [minMs]);

  return !(minElapsed && hydrated);
}
